<template>
    <div>
        <form autocomplete="off" class="form" @submit.prevent="submitForm">
            <div class="form__element">
                <SfInput
                        v-model="propsCustomer.lastName"
                        :error-message="propsCustomer.lastName ? $t('accountForm.lastName.error') : $t('accountForm.lastName.required')"
                        :label="$t('myProfile.profileUpdate.form.lastName')"
                        :valid="lastNameBlur || validLastName(propsCustomer.lastName)"
                        class="form__element--half"
                        name="last-name"
                        required
                        @blur="lastNameBlur = false"
                />

                <SfInput
                        v-model="propsCustomer.firstName"
                        :error-message="propsCustomer.firstName ? $t('accountForm.firstName.error') : $t('accountForm.firstName.required')"
                        :label="$t('myProfile.profileUpdate.form.firstName')"
                        :valid="firstNameBlur || validFirstName(propsCustomer.firstName)"
                        class="form__element--half form__element--half-even"
                        name="first-name"
                        required
                        @blur="firstNameBlur = false"
                />
            </div>
            <div class="form__element">
                <SfInput
                        v-model="propsCustomer.birthDate"
                        :error-message="propsCustomer.birthDate ? $t('accountForm.birthDate.error') : $t('accountForm.birthDate.required')"
                        :label="$t('myProfile.profileUpdate.form.birthDate')"
                        class="form__element--full"
                        name="birth-date"
                        type="date"

                />
            </div>
            <div class="form__element">
                <SfInput
                        v-model="propsCustomer.email"
                        :label="$t('myProfile.profileUpdate.form.email')"
                        class="form__element--full"
                        disabled
                        name="email"
                />
            </div>
            <div class="form__element">
                <SfSelect v-model="propsCustomer.locale" :disabled="false"
                          :label="$t('myProfile.profileUpdate.form.locale')"
                          :required="false"
                          class="form__element--full"
                          errorMessage="This field is not correct."
                >
                    <SfSelectOption v-for="locale in locales" :key="locale.iso" :value="locale.iso">
                        {{ locale.name }}
                    </SfSelectOption>
                </SfSelect>
            </div>
            <!-- newsletter

              <div class="newsletter">
                <div class="content">
                  <ork-toggle v-model="propsCustomer.newsLetterSubscribed"
                              :description="$t('Get our latest news and best plans')"
                              :title=" $t('SUBSCRIBE NEWSLETTER') "
                              name="newsletter" size="medium"></ork-toggle>

                </div>
              </div>
            -->
            <!-- 2FA -->
            <div v-if="customer.customerGroup==='General public'" class="twoFactor">
                <div class="content">
                    <ork-toggle v-model="propsCustomer.twoFactorAuthenticationEnabled"
                                :description=" $t('For more secure access to your account (send a confirmation code by email)') "
                                :title="$t('ENABLE TWO FACTOR AUTH')"
                                name="newsletter"
                                size="medium"></ork-toggle>
                </div>
            </div>

            <div class="form-action">
                <SfButton
                        :disabled="loading"
                        class="sf-button color-secondary"
                        type="submit"
                >
                    <div v-if="loading">
                        <SfLoader :class="{ loader: loading }"
                                  :loading="loading"></SfLoader>
                        {{ $t('Loading') }}
                    </div>
                    <div v-else> {{ $t('myProfile.profileUpdate.form.button') }}</div>
                </SfButton>
            </div>
        </form>
        <SfNotification
                :icon="{icon: icons.info.path, viewBox: icons.info.viewBox}"
                :message="notification.message"
                :type="notification.type"
                :visible="notification.isVisible"
                class="notification"
                @click:close="notification.isVisible = false"
        >
            <template #icon>
                <SfIcon :icon="icons.info.path" :view-box="icons.info.viewBox" class="icon" color="white"/>
            </template>
        </SfNotification>
    </div>
</template>

<script>

import {SfButton, SfInput, SfLoader, SfNotification, SfIcon, SfSelect} from '@storefront-ui/vue';
import Api from '@/api/Api';
import icons from "@/utils/icons";
import OrkToggle from '@/components/Ork/OrkToggle';

export default {
    name: 'profilUpdateForm',
    components: {
        SfIcon,
        SfInput,
        OrkToggle,
        SfButton,
        SfLoader,
        SfNotification,
        SfSelect,
    },
    data() {
        return {
            locales: this._langRouter.translations,
            loading: false,
            error: null,
            valid: false,
            submitted: false,
            firstNameBlur: true,
            lastNameBlur: true,
            notification: {isVisible: false, message: "", type: "success"},
            icons: icons,
            propsCustomer: null,

        }
    },
    computed: {
        customer: {
            get() {
                return {...this.$store.getters.getProfile};
            },

        },
    },
    watch: {
        customer(newCustomer) {
            this.propsCustomer = newCustomer
        }
    },
    created() {
        this.propsCustomer = this.customer
    },
    methods: {

        validate() {
            this.firstNameBlur = false;
            this.lastNameBlur = false;
            this.emailBlur = false;
            return this.validFirstName(this.propsCustomer.firstName) && this.validLastName(this.propsCustomer.lastName);
        },

        validFirstName(firstName) {
            return firstName.length >= 2;
        },

        validLastName(lastName) {
            return lastName.length >= 2;
        },


        submitForm() {
            const onComplete = () => this.loading = false;

            const onError = (e) => {
                this.error = e;
                this.loading = false;
            };

            if (this.validate()) {
                this.loading = true;
                Api.account.updateProfile(this.propsCustomer).then(
                    (data) => {
                        onComplete();
                        this.notification = {
                            isVisible: true,
                            message: this.$i18n.t('myProfile.profileUpdate.notifications.success'),
                            type: 'success'
                        }
                    },
                    err => {
                        onError(err);
                        this.notification = {
                            isVisible: true,
                            message: this.$i18n.t('myProfile.profileUpdate.notifications.error'),
                            type: 'danger'
                        }
                    }
                )
            }
        },
    }
}
</script>

<style lang='scss' scoped>
form {
  .form__element {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    @include for-mobile {
      gap: 0;
    }

    &--full {
      flex: 1;
    }

    &--half {
      flex: 1;
      @include for-mobile {
        flex: none;
        width: 100%;
      }


    }
  }
}

.form-action {
  margin: var(--spacer-base) auto;
  display: flex;

  ::v-deep {
    .sf-button {
      margin: auto;
      flex: 0;
      white-space: nowrap;
      min-height: 52px;
    }
  }
}

.newsletter, .twoFactor {
  margin: var(--spacer-base) 0;
  padding: var(--spacer-base);
  background-color: var(--_c-primary-sidebar);
  border-radius: 4px;
}


</style>